import { render } from "./Internship_Certificate.vue?vue&type=template&id=95a3e2de"
import script from "./Internship_Certificate.vue?vue&type=script&lang=js"
export * from "./Internship_Certificate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__